export enum ToastType {
  SUCCESS = 'success',
  INFO = 'info',
  DANGER = 'danger',
  WARNING = 'warning',
}
